import emailjs from "emailjs-com";
// import type { ContactModel } from "~/models/contactModel";
// import { useImageCompression } from "@/composables/useImageCompression";
export function useEmailJS() {
  // async function convertFilesToBase64(files: File[]): Promise<{ filename: string; content: string }[]> {
  //     const { compressImages, compressedImages } = useImageCompression();
  //     await compressImages(files); // Compress images first
  //     console.log("Compressed images:", compressedImages.value);
  //     return Promise.all(compressedImages.value.map((file) => {
  //         return new Promise<{ filename: string; content: string }>((resolve, reject) => {
  //             const reader = new FileReader();
  //             reader.readAsDataURL(file);
  //             reader.onload = () => resolve({
  //                 filename: file.name,
  //                 content: reader.result?.toString().split(",")[1] || "", // Extract Base64 content
  //             });
  //             reader.onerror = (error) => reject(error);
  //         });
  //     }));
  // }

  async function sendEmail(
    formEl: HTMLFormElement
  ): Promise<{ success: boolean; message: string }> {
    try {
      const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID;
      const TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;
      const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;
      const response = await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formEl, PUBLIC_KEY);

      if (response.status === 200) {
        return {
          success: true,
          message: "Email sent successfully!"
        };
      } else {
        return {
          success: false,
          message: "Submission failed. Please try again."
        };
      }
    } catch (err) {
      console.error("EmailJS error:", err);
      return {
        success: false,
        message: "An error occurred during submission. Please try again later."
      };
    }
  }

  // async function sendEmail(
  //     model: ContactModel
  //   ): Promise<{ success: boolean; message: string }> {
  //     try {
  //       const SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID;
  //       const TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID;
  //       const PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY;
  //       let base64Attachments: { filename: string; content: string }[] = [];

  //       if (model.project.images.length > 0)
  //         // Convert files to Base64 and compress them
  //         base64Attachments = await convertFilesToBase64(model.project.images);
    
  //       // Construct the email parameters
  //       const emailParams = {
  //         name: model.customer.name,
  //         email: model.customer.email,
  //         phone: model.customer.phone,
  //         address: `${model.customer.address}, ${model.customer.city}, ${model.customer.state}, ${model.customer.zip}`,
  //         description: model.project.description,
  //         preferredContact: model.preferredContact,
  //         attachments: base64Attachments.map((x) => ({
  //           name: x.filename, // Attach images in Base64 format
  //           data: x.content, // Base64 content
  //         })),
  //       };
    
  //       // Send the email
  //       const response = await emailjs.send(SERVICE_ID, TEMPLATE_ID, emailParams, PUBLIC_KEY);
    
  //       if (response.status === 200) {
  //         return { success: true, message: "Email sent successfully!" };
  //       } else {
  //         return { success: false, message: "Email submission failed. Please check attachment sizes." };
  //       }
  //     } catch (error) {
  //       return { success: false, message: "Failed to send email. Please try again." };
  //     }
  //   }
  return { sendEmail };
}